const FILTER_TYPE = {
  AGENT: "agent",
  DISEASE: "disease",
};

const SORT_FIELD = {
  regimen: "regimenTitle",
  indications: "indications",
  template: "templateId",
};

const hasAgent = (regimen, agentName) =>
  regimen.relatedAgents?.some((agent) => agent.name === agentName);
const hasDisease = (regimen, diseaseName) =>
  regimen.diseaseName === diseaseName;

const FILTER_EVALUATOR = {
  [FILTER_TYPE.AGENT]: hasAgent,
  [FILTER_TYPE.DISEASE]: hasDisease,
};

const filterRegimens = ({
  regimens,
  filterType,
  filterOption,
  searchUtils,
}) => {
  const { highlightHit, match, hasQuery } = searchUtils;
  const filteredRegimens = regimens.reduce((acc, regimen) => {
    const newRegimen = {
      ...regimen,
      uuid: regimen.subRegimens
        ? `group-${regimen.templateId}`
        : regimen.templateId,
    };

    if (regimen.subRegimens) {
      const newSubRegimens = filterRegimens({
        regimens: regimen.subRegimens,
        filterType,
        filterOption,
        searchUtils,
      });

      if (!newSubRegimens.length) {
        return acc;
      }

      newRegimen.subRegimens = sortRegimens(
        newSubRegimens,
        SORT_FIELD.template
      );
    }

    newRegimen.displayRegimenTitle = highlightHit(regimen.regimenTitle);
    newRegimen.displayCourseTitle = highlightHit(regimen.courseTitle);
    newRegimen.displayIndications = highlightHit(regimen.indications);
    newRegimen.displayTemplateId = highlightHit(regimen.templateId);

    if (newRegimen.subRegimens?.length) {
      acc.push(newRegimen);
      return acc;
    }

    const hasMatch =
      match(regimen.regimenTitle) ||
      match(regimen.courseTitle) ||
      match(regimen.indications) ||
      match(regimen.templateId);

    if (hasQuery && !hasMatch) {
      return acc;
    }

    if (filterOption) {
      const filterFn = FILTER_EVALUATOR[filterType];
      if (!filterFn || !filterFn(regimen, filterOption)) {
        return acc;
      }
    }

    acc.push(newRegimen);
    return acc;
  }, []);

  return filteredRegimens;
};

const sortRegimens = (regimens, sortFieldName) =>
  regimens.toSorted((a, b) =>
    a[sortFieldName] && b[sortFieldName]
      ? a[sortFieldName].localeCompare(b[sortFieldName], undefined, {
          numeric: true,
        })
      : 0
  );

export const transformRegimens = ({
  regimens,
  filterType,
  filterOption,
  sortOption,
  searchUtils,
}) => {
  const filteredRegimens = filterRegimens({
    regimens,
    filterType,
    filterOption,
    searchUtils,
  });
  const sortedRegimens = sortRegimens(filteredRegimens, SORT_FIELD[sortOption]);

  return sortedRegimens;
};
